export const storeAccessToken = (data: any) => {
  try {
    localStorage.setItem("access_token", data.access_token);
    if (data.refresh_token) {
      localStorage.setItem("refresh_token", data.refresh_token);
    }
    if (data.user) {
      setUser(data.user);
    } else {
      console.warn("No user info found in token response.");
    }
    console.log("Access token stored successfully!");
  } catch (e) {
    console.error("Failed to save the access token.", e);
  }
};

export const retrieveAccessToken = () => {
  try {
    const value = localStorage.getItem("access_token");
    if (value !== null) {
      console.log("Retrieved access token:", value);
      return value;
    }
    return null;
  } catch (e) {
    console.error("Failed to fetch the access token.", e);
    return null;
  }
};

export const clearAccessToken = () => {
  try {
    localStorage.removeItem("access_token");
    removeUser();
    console.log("Access token cleared successfully!");
  } catch (e) {
    console.error("Failed to clear the access token.", e);
  }
};

export const setUser = (userData: any) => {
  if (userData === undefined || userData === null) {
    console.warn("⚠️ Attempted to set undefined or null user");
    return;
  }
  localStorage.setItem("user", JSON.stringify(userData));
};

export const getUser = () => {
  try {
    const userData = localStorage.getItem("user");
    if (!userData || userData === "undefined") return null;
    return JSON.parse(userData);
  } catch (e) {
    console.error("Failed to parse user from localStorage", e);
    return null;
  }
};

export const removeUser = () => {
  localStorage.removeItem("user");
};

export const getUserId = () => {
  try {
    const userData = localStorage.getItem("user");
    if (userData) {
      const user = JSON.parse(userData);
      console.log("Retrieved user ID:", user.id);
      return user.id;
    } else {
      console.warn("No user data found.");
      return null;
    }
  } catch (e) {
    console.error("Failed to fetch user ID.", e);
    return null;
  }
};
